import { useEffect } from "react";
import { colors, fonts, glyphs } from "../../Styles";
import { Graph_QL, useGetAutopig } from "../../Services";
import { numberConverter } from "../../Definitions/valueTypes";
import { UNIT } from "../BaseComponents";

export default function AutoPigModel() {

  // var Connections = Graph_QL.create([{domain:"demo"}, {domain:"tester"}])
  const {getState, stateData, } = useGetAutopig(Graph_QL.create([{domain:"demo", gate:2, device:40}]))

  useEffect(() => {
    let interval = setInterval(() => {
      getState(undefined, 1)
      // console.log("running")
    }, 1000)
    return () => {
      // console.log("clean")
      clearInterval(interval)
    }
  },[])
  
  useEffect(() => {
    // console.log("Data", stateData)
    getState(undefined,1)
  }, [stateData])

  const liveScale = stateData&&stateData[0] ? numberConverter(stateData[0].value1) : "No Data"
  const minScale = stateData&&stateData[0] ? numberConverter(stateData[0].value5) : "No Data"
  const maxScale = stateData&&stateData[0] ? numberConverter(stateData[0].value6) : "No Data"
  const todayAvg = stateData&&stateData[0] ? numberConverter(stateData[0].value2,100) : "No Data"
  const scaleCount = stateData && stateData[0] ? stateData[0].value3 : "No Data"
  
  // #region | Auto Pig Model Svg
  const autoPig = (
    <svg xmlns="http://www.w3.org/2000/svg" width="352" height="357" viewBox="0 0 352 357" fill="none">
      <path // Bottom
        d="M295.063 333.5L307.587 347H43.916L56.4365 333.5H295.063Z"
        fill={colors.greyPrimary}
        stroke={colors.greySecondary}
        stroke-width="2"
      />
      <path // Bottom horizontal line
        d="M46.2734 343H305.213"
        stroke={colors.greySecondary}
        stroke-width="2"
      />
      <path // Base
        d="M100.3 47H251.2C251.991 47 252.707 47.4655 253.028 48.1877L350.328 267.112C350.441 267.368 350.5 267.645 350.5 267.924V353.5C350.5 354.605 349.605 355.5 348.5 355.5H316.37C315.815 355.5 315.285 355.269 314.907 354.863L295.593 334.137C295.215 333.731 294.685 333.5 294.13 333.5H57.3701C56.8151 333.5 56.2852 333.731 55.9069 334.137L36.5931 354.863C36.2148 355.269 35.6849 355.5 35.1299 355.5H3C1.89543 355.5 1 354.605 1 353.5V267.924C1 267.645 1.05872 267.368 1.17238 267.112L98.4721 48.1877C98.7931 47.4655 99.5094 47 100.3 47Z"
        fill={colors.graphBlueTen}
        stroke={colors.greyDarkPrimary}
        stroke-width="1"
      />
      <path // Top
        d="M111.005 16.7623L175.039 1.60899C175.342 1.53732 175.658 1.53732 175.961 1.60899L239.995 16.7623C240.626 16.9114 241.145 17.3564 241.388 17.9565L254.545 50.3798C254.763 50.9153 254.369 51.5004 253.791 51.5004C253.35 51.5004 252.99 51.8505 252.977 52.2908L252.586 65.5886C252.538 67.2104 251.209 68.5004 249.587 68.5004H101.413C99.7906 68.5004 98.4621 67.2104 98.4144 65.5886L98.0232 52.2903C98.0103 51.85 97.6497 51.4999 97.2093 51.4999C96.6314 51.4999 96.2374 50.9148 96.4547 50.3794L109.612 17.9565C109.855 17.3564 110.374 16.9114 111.005 16.7623Z"
        fill={colors.greyPrimary}
        stroke={colors.greySecondary}
        stroke-width="2"
      />
      <path // Top horizontal line
        d="M97.1797 51.5H253.725"
        stroke={colors.greySecondary}
        stroke-width="2" />
    </svg>
  )
  // #endregion

  return(
      <div style={{width: "352px", height: "357px", position: "relative"}}>
      <div style={{position: "absolute"}}>{autoPig}</div>
      
      
      <div style={{display: "flex", alignItems: "center", justifyContent: "center", position: "relative", width: "100%", height: "100%", flexDirection: "column", gap: "30px", paddingTop: "25px"}}>
        
        {/* Live Scale */}
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
          <div style={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "10px"}}>
            <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>Live Scale</p>
            <p style={{...fonts.header, ...fonts.fontSize0, color: colors.greyLightTertiary, backgroundColor: colors.graphBlueSeven, borderRadius: "10px", padding: "5px 10px", textAlign: "center", minWidth: "100px"}}>{liveScale}</p>
            <UNIT content={"Kg"} color={colors.greyLightTertiary} glyph={<glyphs.Kg size="15px"/>}/>, 
          </div>
        </div>

        {/* Today's Weights */}
        <div style={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "10px"}}>
          <div style={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "0px"}}>
            <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>Today's Weights ({scaleCount})</p>
            {/* <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary}}>Weight count: {scaleCount}</p> */}
          </div>
          <div style={{width: "fit-content", borderWidth: "2px 0px", borderColor: colors.graphBlueSeven, borderStyle: "solid", padding: "5px 0px", display: "flex", gap: "60px"}}>
            <div style={{display: "flex", flexDirection: "column", alignItems: "start", justifyContent: "center", gap: "5px"}}>
              <p style={{...fonts.header, ...fonts.fontSize4, color: colors.graphBlueSeven}}>Exp. Min.</p>
              <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>{minScale}</p>
            </div>
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "5px"}}>
              <p style={{...fonts.header, ...fonts.fontSize4, color: colors.graphBlueSeven}}>Avg.</p>
              <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>{todayAvg}</p>
            </div>
            <div style={{display: "flex", flexDirection: "column", alignItems: "end", justifyContent: "center", gap: "5px"}}>
              <p style={{...fonts.header, ...fonts.fontSize4, color: colors.graphBlueSeven}}>Exp. Max.</p>
              <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>{maxScale}</p>
            </div>
          </div>
          <UNIT content={"Kg"} color={colors.graphBlueSeven} glyph={<glyphs.Kg size="15px" fillColor={colors.graphBlueSeven}/>}/>, 
        </div>
      
      </div>
    </div>
  )
}